import { FC, HTMLAttributes, ReactNode } from 'react'

import { Details, DigitizationSneakPeekVisual, Body as StyledBody, Visual } from './styles'

const Container: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className, ...rest }) => {
  return (
    <StyledBody className={className} {...rest}>
      {children}
    </StyledBody>
  )
}

const Header: FC<{
  backgroundColor?: string
  children?: ReactNode
  isDigitization?: boolean
}> = ({ children, backgroundColor, isDigitization }) => {
  return isDigitization ? (
    <DigitizationSneakPeekVisual $backgroundColor={backgroundColor}>
      {children}
    </DigitizationSneakPeekVisual>
  ) : (
    <Visual $backgroundColor={backgroundColor}>{children}</Visual>
  )
}

const Body: FC<{ children?: ReactNode }> = ({ children }) => {
  return <Details> {children}</Details>
}

export const Template = {
  Container,
  Header,
  Body,
}
